var React = require('react');

function ShareGeneralIcon (props) {
    return React.createElement("svg",props,React.createElement("g",{"transform":"translate(0 -2)"},React.createElement("g",{"transform":"translate(0 -384)"},React.createElement("path",{"d":"M0,388H6.75l-2.5,2H2v7H12v-2l2-1.6V399H0Zm16,2-5,4v-1.992a8.965,8.965,0,0,0-7.033,3.015A7.274,7.274,0,0,1,11,387.977V386Zm0,0","fill":"#fff","fillRule":"evenodd"}))));
}

ShareGeneralIcon.defaultProps = {"width":"16","height":"13","viewBox":"0 0 16 13"};

module.exports = ShareGeneralIcon;

ShareGeneralIcon.default = ShareGeneralIcon;
